import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AlertBox from "../../component/AlertBox";
import { LinearProgress, Step, StepButton, Stepper } from "@mui/material";
import ButtonCompo from "../../component/ButtonCompo";
import InputField from "../../component/InputField";
import { useForm } from "react-hook-form";
import SelectField from "../../component/SelectField";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import dayjs from "dayjs";
import { FiAlertCircle } from "react-icons/fi";

function OnboardingEmployee() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeData = useSelector((state) => state.employee?.employeeData);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [salaryStructure, setSalaryStructure] = useState([]);
  const [copySalaryStructure, setCopySalaryStructure] = useState([]);
  const [salaryCalculationReload, setSalaryCalculationReload] = useState(false);
  const [allProjects, setAllProjects] = useState([]);
  const [managers, setManagers] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedManager, setSelectedManager] = useState("");
  const [selectedGender, setSelcetdGender] = useState("");
  const [dob, setDob] = useState(new Date());
  const [onBoardingDate, setOnboardingDate] = useState(undefined);
  const [startShieft, setStartShieft] = useState();
  const [endShieft, setEndShieft] = useState();
  const [workType, setWorkType] = useState("");

  // salary calculation params
  const [basic, setBasic] = useState(0);
  const [ctc, setCtc] = useState(0);
  const [inHand, setInHand] = useState(0);

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeData !== null &&
      employeeData?.admin?.onBoardingAccess === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeData]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  //fetch all salary structure
  async function getSalaryStructure() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/salary-structure`,
        method: "get",
        withCredentials: true,
      });
      //console.log(res.data?.data);
      const rawStructure = res.data?.data;
      setSalaryStructure(res.data?.data);
      let newStructure = rawStructure?.map((e) => {
        const element = { ...e, amount: 0 };
        return element;
      });
      setCopySalaryStructure(newStructure);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Salary structure fetch failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getSalaryStructure();
  }, []);

  async function employeeOnboard(data) {
    if (selectedManager?.length === 0) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please select a manager");
      return null;
    }
    if (dob?.$d === undefined) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please select the date of birth");
      return null;
    }
    if (startShieft?.$d === undefined || endShieft?.$d === undefined) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please select both shieft time");
      return null;
    }
    if (onBoardingDate === undefined) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please select the onboarding date");
      return null;
    }
    // if (basic === 0) {
    //   setOpen(true);
    //   setSuccess(false);
    //   setMessage("Please enter salary details");
    //   return null;
    // }
    /* hey developer, do you remember that I merge
    two value in a string to set as "value" attribute of <option> ?
    I hope you do. Now, I am splitting the string two extract 
    two values differently from that string. */
    const splitedManagerValue = selectedManager?.split("-");
    // we need to check whether the value splitted well or not
    if (!Array.isArray(splitedManagerValue)) {
      setOpen(true);
      setSuccess(false);
      setMessage("Something went wrong");
      return null;
    }
    // console.log(copySalaryStructure);
    // structuring object for backend
    let postData = {
      ...data,
      dob: dob?.$d,
      onBoardingDate: onBoardingDate?.$d,
      managerId: splitedManagerValue[0],
      managerRole: splitedManagerValue[1],
      startShieftTime: new Date(startShieft?.$d).toLocaleTimeString(),
      endShieftTime: new Date(endShieft?.$d).toLocaleTimeString(),
      ctc: ctc,
      project: selectedProject,
      salaryStructure: copySalaryStructure,
      basic: basic,
      gender: selectedGender,
      workType: workType,
      inHand: inHand,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/employee/onboarding`,
        method: "post",
        data: postData,
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setOpen(true);
        setSuccess(true);
        setMessage("Employee onboarded successfully");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // update salary structure value
  const handleChangeSalary = (index, value) => {
    setCopySalaryStructure((prev) => {
      let newArr = [...prev];

      newArr[index] = { ...newArr[index], amount: Number(value) };

      //-------------------------------------------------------------------
      //--------------------Automated Calculations-------------------------
      // update the ctc when user update any value manually
      // let totalCtc = Number(ctc); // Start with basic as the base for CTC calculation
      // newArr.forEach((f) => {
      //   if (f?.isEnable === false) return;

      //   // no calculation required, direct update with amount
      //   let newAmount = Number(f?.amount);

      //   // check deduction
      //   if (f?.isDeduction) {
      //     totalCtc += newAmount;
      //   } else {
      //     totalCtc -= newAmount;
      //   }
      // });
      //-------------------------------------------------------------------

      // Set both the updated array and calculated CTC
      // setBasic(totalCtc);

      return newArr;
    });
  };

  //fetch all projects
  async function getProjects() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/projects`,
        method: "get",
        withCredentials: true,
      });
      // save the api data
      let rawData = res.data?.data;
      // go through every element
      let selectfieldData = rawData?.map((e) => {
        // structure the data as per selectfield data structure
        let newObj = {
          title: e,
          value: e,
        };
        return newObj;
      });
      setAllProjects(selectfieldData);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Projects fetch failed");
    } finally {
      setLoading(false);
    }
  }

  //fetch all projects
  async function getManagers() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/all/managers`,
        method: "get",
        withCredentials: true,
      });
      //console.log(res.data?.data)
      let rawData = res.data?.data;
      let selectfieldData = [];
      rawData?.map((e) => {
        let newObj = {
          title:
            e?.managerRole === "CompanySuperadmin"
              ? `${e?.name}(Superadmin)`
              : e?.name, // add a extra reference for superadmin
          value: `${e?.mangerId}-${e?.managerRole}`, // we can't set object as "value" attribute of <option> tag but we can set string. I combine two data in a string.
        };
        selectfieldData.push(newObj);
      });
      setManagers(selectfieldData);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Projects fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // gender array
  const genderArray = [
    {
      title: "Male",
      value: "Male",
    },
    {
      title: "Female",
      value: "Female",
    },
    {
      title: "Others",
      value: "Others",
    },
  ];

  // work type array
  const workTypeArray = [
    {
      title: "Work From Office",
      value: "WFO",
    },
    {
      title: "Work From Home",
      value: "WFH",
    },
    {
      title: "Hybrid",
      value: "Hybrid",
    },
  ];

  const stepsArray = [
    "Personal & Job Details",
    "Shift Details",
    "Salary Details",
  ];
  const [activeStep, setActiveStep] = useState(0);

  console.log(errors);

  useEffect(() => {
    getProjects();
    getManagers();
  }, []);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center flex-col">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Onboard An Employee
          </h1>
          <div className="mt-[3rem] w-full border p-8 rounded-lg shadow-lg">
            <Stepper activeStep={activeStep} alternativeLabel>
              {stepsArray.map((label, index) => (
                <Step key={index}>
                  <StepButton color="inherit">
                    <p className="text-[17px] font-medium">{label}</p>
                  </StepButton>
                </Step>
              ))}
            </Stepper>
            {Object.keys(errors).length > 0 && (
              <p className="flex justify-center items-center gap-1 text-red-500 font-medium mt-8 text-[17px]">
                <FiAlertCircle className="text-[18px] text-red-500" />
                Check all the steps, total {Object.keys(errors).length} input is
                wrong
              </p>
            )}
            <form className="mt-5" onSubmit={handleSubmit(employeeOnboard)}>
              <div
                className={`w-full mt-10 ${activeStep === 0 ? "" : "hidden"}`}
              >
                {/* <p className="mb-5 font-medium text-[17px]">
                  Personal & Job Details
                </p> */}
                <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-10">
                  <InputField
                    label="Name"
                    {...register("name", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    error={errors?.name}
                  />
                  <InputField
                    label="Professional Email"
                    type="email"
                    {...register("email", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    error={errors?.email}
                  />
                  <InputField
                    label="Personal Email"
                    type="email"
                    {...register("personalEmail", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    error={errors?.email}
                  />
                  <InputField
                    label="Role"
                    {...register("role", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    error={errors?.role}
                  />
                  <InputField
                    label="Designation"
                    {...register("designation", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    error={errors?.designation}
                  />
                  <InputField
                    label="Office Location"
                    {...register("officeLocation", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    error={errors?.officeLocation}
                  />
                  <InputField
                    label="Phone Number"
                    {...register("phoneNumber", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      minLength: {
                        value: 10,
                        message:
                          "Phone number should not be less than 10 digits",
                      },
                      maxLength: {
                        value: 10,
                        message:
                          "Phone number should not be greater than 10 digits",
                      },
                      setValueAs: (value) => value.trim(),
                    })}
                    error={errors?.phoneNumber}
                  />
                  <InputField
                    label="Probation Period(in months)"
                    {...register("probationPeriod", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    error={errors?.probationPeriod}
                  />
                  <SelectField
                    label="Manager"
                    value={selectedManager}
                    setValue={(e) => setSelectedManager(e?.target?.value)}
                    valueArray={managers}
                  />
                  {/* <SelectField
                    label="Project"
                    value={selectedProject}
                    setValue={(e) => setSelectedProject(e?.target?.value)}
                    valueArray={allProjects}
                  /> */}
                  <SelectField
                    label="Gender"
                    value={selectedGender}
                    setValue={(e) => setSelcetdGender(e?.target?.value)}
                    valueArray={genderArray}
                  />
                  <SelectField
                    label="Work Type"
                    value={workType}
                    setValue={(e) => setWorkType(e?.target?.value)}
                    valueArray={workTypeArray}
                  />
                  <InputField
                    label="Department"
                    {...register("department", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    error={errors?.department}
                  />
                  <DatePicker
                    label="Date of birth"
                    onChange={(e) => setDob(e)}
                  />
                  <DatePicker
                    label="Onboarding Date"
                    onChange={(e) => setOnboardingDate(e)}
                  />
                </div>
              </div>
              <div className={`mt-8 ${activeStep === 1 ? "" : "hidden"}`}>
                {
                  <DemoContainer
                    components={["MobileTimePicker", "MobileTimePicker"]}
                  >
                    <div className="w-full">
                      {/* <p className="text-[17px] font-medium">Shieft</p> */}
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-10 mt-5">
                        <MobileTimePicker
                          label="From"
                          className="w-full"
                          onChange={setStartShieft}
                        />
                        <MobileTimePicker
                          label="To"
                          className="w-full"
                          onChange={setEndShieft}
                        />
                      </div>
                    </div>
                  </DemoContainer>
                }
              </div>
              <div
                className={`mt-8 w-full ${activeStep === 2 ? "" : "hidden"}`}
              >
                {/* <p className="mb-5 font-medium text-[17px]">Salary Details</p> */}
                <div className="mt-5 w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-10">
                  <InputField
                    label={"CTC"}
                    onChange={(e) => setCtc(e?.target?.value)}
                  />
                  {copySalaryStructure?.map((e, i) =>
                    e?.isEnable === true ? (
                      <InputField
                        label={e?.name}
                        onChange={(e) =>
                          handleChangeSalary(i, e?.target?.value)
                        }
                        key={i}
                      />
                    ) : (
                      ""
                    )
                  )}
                  <InputField
                    label={"Basic"}
                    onChange={(evt) => setBasic(evt?.target?.value)}
                  />
                  <InputField
                    label={"In Hand"}
                    onChange={(evt) => setInHand(evt?.target?.value)}
                  />
                </div>
              </div>
              <div className="mt-8 w-full flex justify-between items-center gap-5">
                <section className="w-[10rem]">
                  {activeStep !== 0 && (
                    <ButtonCompo onClick={() => setActiveStep(0)}>
                      Go To first
                    </ButtonCompo>
                  )}
                </section>
                <section className="w-full flex justify-end items-end gap-5">
                  {activeStep !== 0 && (
                    <ButtonCompo
                      onClick={() => setActiveStep((prev) => prev - 1)}
                    >
                      Back
                    </ButtonCompo>
                  )}
                  {activeStep === stepsArray.length - 1 ? (
                    <ButtonCompo variant={"contained"} type="submit">
                      onboard
                    </ButtonCompo>
                  ) : (
                    ""
                  )}
                  {activeStep !== stepsArray.length - 1 && (
                    <ButtonCompo
                      variant={"contained"}
                      onClick={() => setActiveStep((prev) => prev + 1)}
                    >
                      Next
                    </ButtonCompo>
                  )}
                </section>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default OnboardingEmployee;
